import {useEffect, useState} from "react";
import api from "../../../services/api";

/**
 * 조선총독부 직원록 데이터 요청 훅
 */
export const useGetTocsAndRelatedSchoolsByBookId = (book_id) => {
    const [datas, setDatas] = useState([]);

    useEffect(() => {
        const getBookInfo = async () => {
            try {
                // book_id 검증
                if (!book_id) {
                    throw new Error("book_id 필수 입력항목입니다.");
                }

                if (isNaN(book_id)) {
                    throw new Error("book_id 는 숫자만 가능합니다.");
                }

                const response = await api.post("/get_tocs_and_related_schools_by_book_id", {
                    book_id: book_id,
                    toc_all: false,
                    keyword: "school",
                });

                if (!response?.data?.data || !Array.isArray(response.data.data)) {
                    throw new Error("Invalid response format");
                }

                // 데이터 포맷 변경
                const formattedData = response.data.data.map((item) => ({
                    toc_id: item.toc_id,
                    toc_title: item.toc_title,
                    toc_title_ko: item.toc_title_ko,
                    n_psnorders: item.n_psnorders,
                    related_schools: item.related_schools.map((school) => ({
                        school_id: school.school_id,
                        primaryname: school.primaryname,
                        primaryname_ko: school.primaryname_ko,
                    })),
                }));

                setDatas(formattedData);
            } catch (error) {
                throw new Error("데이터를 가져오는 중 오류가 발생했습니다.");
            }
        };

        getBookInfo();
    }, [book_id]); // book_id를 의존성 배열에 추가

    return datas;
};

/**
 * 조선총독부 직원록 데이터 중 인물명 및 상태
 * @param tocId
 * @returns {Promise<null>}
 */
export const fetchPersonOrders = async (tocId) => {
    if (!tocId) return;

    let res = null;

    try {
        const response = await api.get(`/get_psnorders_by_toc_id/${tocId}`);
        res = response.data.data;

    } catch (err) {
        console.error("Error fetching person orders:", err);
    }

    return res;
};

